import service from '@/services'
import QueryString from 'qs'

// Module Vuex analisis
export default {
  namespaced: true,
  state: {
    datas: [],
    total: 0,
  },
  getters: {
    getData: state => id => state.datas.find(item => item.id == id),
    getDataBrand: state => id => state.datas.find(item => item.id == id),
  },
  mutations: {
    SET_DATA(state, data) {
      state.datas = data
    },
    SET_TOTAL_DATA(state, data) {
      state.total = data
    },
  },
  actions: {
    async getData({ commit }, params = {}) {
      try {
        const config = {
          url: '/analisis',
          method: 'get',
          params,
          paramsSerializer: params => QueryString.stringify(params),
          headers: {
            Authorization: `${localStorage.tokenType} ${localStorage.token}`,
          },
        }
        const response = await service.sendRequest(config)

        const result = response.data && response.data.data ? response.data.data : []
        const total = response.data ? response.data.total : result.length
        commit('SET_DATA', result)
        commit('SET_TOTAL_DATA', total)

        return Promise.resolve()
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async getDataById({}, id) {
      try {
        const config = {
          url: `/analisis/${id}`,
          method: 'get',
          // params,
          // paramsSerializer: params => QueryString.stringify(params),
          headers: {
            Authorization: `${localStorage.tokenType} ${localStorage.token}`,
          },
        }

        const response = await service.sendRequest(config)
        const body = response.data
        // Lumen may return the record at top-level or under `.data`
        const record =
          body && body.data && typeof body.data === 'object' && !Array.isArray(body.data)
            ? body.data
            : body

        return Promise.resolve(record)
      } catch (e) {
        return Promise.reject(e)
      }
    },
    async save({}, payload = {}) {
      try {
        const config = {
          url: '/input/analisis',
          method: 'post',
          data: payload,
          headers: {
            Authorization: `${localStorage.tokenType} ${localStorage.token}`,
          },
        }

        const response = await service.sendRequest(config)

        return Promise.resolve(response.data)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async getDataBrand({ commit }, params = {}) {
      try {
        const config = {
          url: '/brand-analisis',
          method: 'get',
          params,
          paramsSerializer: params => QueryString.stringify(params),
          headers: {
            Authorization: `${localStorage.tokenType} ${localStorage.token}`,
          },
        }
        const response = await service.sendRequest(config)

        const result = response.data && response.data.data ? response.data.data : []
        commit('SET_DATA', result)

        return Promise.resolve()
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async saveBrand({}, payload = {}) {
      try {
        const config = {
          url: '/input/brand-analisis',
          method: 'post',
          data: payload,
          headers: {
            Authorization: `${localStorage.tokenType} ${localStorage.token}`,
          },
        }

        const response = await service.sendRequest(config)

        return Promise.resolve(response.data)
      } catch (error) {
        return Promise.reject(error)
      }
    },
  },
}
